module.exports = __webpack_public_path__ + "img/2.c82d79a6.png";